import { ChatMessages } from './ChatMessages';
import { ChatInput } from './ChatInput';
import { ChatHeader } from './ChatHeader';

export const ChatArea = ({ 
  activeUseCase, 
  selectedModel, 
  setSelectedModel, 
  isModelDropdownOpen, 
  setIsModelDropdownOpen, 
  messages, 
  isTyping, 
  copiedId, 
  setCopiedId, 
  handleTryAgain, 
  handleEdit, 
  messagesEndRef, 
  input, 
  setInput, 
  isRecording, 
  toggleRecording, 
  handleSendMessage, 
  tokenUsage, 
  darkMode,
  onShareChat,
  onPinChat,
  onArchiveChat,
  onDeleteChat,
  isPinned = false,
  hideHeaderAndInput = false,
  conversationId,
  models = [],
}) => (
  <div className="flex-1 flex flex-col h-full relative">
    {/* Floating header + fade overlay — sits above messages, not in flow */}
    {!hideHeaderAndInput && (
      <div className="absolute top-0 left-0 right-0 z-20 pointer-events-none">
        {/* Fade gradient — messages dissolve into this */}
        <div className="h-24 bg-gradient-to-b from-white via-white/70 to-transparent dark:from-[#0f172a] dark:via-[#0f172a]/60 dark:to-transparent" />
        {/* Buttons row — pointer-events back on so they're clickable */}
        <div className="absolute top-4 sm:top-5 left-0 right-0 pointer-events-auto">
          <ChatHeader
            activeUseCase={activeUseCase}
            selectedModel={selectedModel}
            setSelectedModel={setSelectedModel}
            isModelDropdownOpen={isModelDropdownOpen}
            setIsModelDropdownOpen={setIsModelDropdownOpen}
            onShareChat={onShareChat}
            onPinChat={onPinChat}
            onArchiveChat={onArchiveChat}
            onDeleteChat={onDeleteChat}
            isPinned={isPinned}
            conversationId={conversationId}
            models={models}
          />
        </div>
      </div>
    )}

    {/* Messages — scroll under the floating header */}
    <div className="flex-1 overflow-y-auto">
      <ChatMessages
        activeUseCase={activeUseCase}
        messages={messages}
        isTyping={isTyping}
        copiedId={copiedId}
        setCopiedId={setCopiedId}
        handleTryAgain={handleTryAgain}
        handleEdit={handleEdit}
        messagesEndRef={messagesEndRef}
        darkMode={darkMode}
      />
    </div>

    {/* Input */}
    {!hideHeaderAndInput && (
      <ChatInput
        input={input}
        setInput={setInput}
        isRecording={isRecording}
        toggleRecording={toggleRecording}
        handleSendMessage={handleSendMessage}
        isTyping={isTyping}
        tokenUsage={tokenUsage}
      />
    )}
  </div>
);